export default "__VITE_ASSET__cp3Sf47U__"